var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getHeader = void 0;
  function getHeader(response, header) {
    for (const [headerKey, headerValue] of Object.entries(response.headers)) {
      if (headerKey.toLowerCase() === header.toLowerCase()) {
        return headerValue;
      }
    }
    return undefined;
  }
  exports.getHeader = getHeader;
  return exports;
}